export default {
    selectLearningResultList:
        "/gateway/huilianOperation/learningResultcs/selectLearningResultList?activity=365", //学习记录列表
    statisticsLearningResult:
        "/gateway/huilianOperation/learningResultcs/statisticsLearningResult?activity=365", //学习记录统计
};



// WEBPACK FOOTER //
// ./src/safetyTrainingCourses/record/api.js